export default __webpack_public_path__ + "static/media/avatar.2c8bb687.svg";